(function ($) {
  var $ = jQuery = $;

  $(window).scroll(function() {    
    if($(document).height() > 1000) {
      var windowScrollHeight = $(window).scrollTop();
      if (windowScrollHeight >= 50) {
          $("body:not(.template-cart) .header-group").addClass("stuck");
      }
      if (windowScrollHeight <= 50) {
          $("body:not(.template-cart) .header-group").removeClass("stuck");
      }
    }
  });

  $('.product-image').mouseenter(function() {
    $(this).attr('data-product-featured-media','');
  });

  $('.product-image').mouseleave(function() {
    $(this).removeAttr('data-product-featured-media');
  });

/* Hide Silver plated options 
const finishSelector = document.querySelector(
  '.option-selector[data-option-name="choose your option"]'
);

if (finishSelector) {
  const sterling = finishSelector.querySelector(
    'input[value="Sterling Silver"]'
  );

  if (sterling) {
    sterling.checked = true;
    sterling.dispatchEvent(new Event('change', { bubbles: true }));
  }

  finishSelector.style.display = 'none';
}
  end Hide Silver plated options */

const material1 = document.querySelector('.product-form-block[data-block-name="Materials-1"]');
const material2 = document.querySelector('.product-form-block[data-block-name="Materials-2"]');

const radios = document.querySelectorAll(
  '[data-option-name="choose your option"] input[type="radio"]'
);

if (material2) {
  material2.style.display = "none";
}

function toggleMaterials() {
  const selected = document.querySelector(
    '[data-option-name="choose your option"] input[type="radio"]:checked'
  );

  if (!selected || !material1 || !material2) return;

  if (selected.value.trim().toLowerCase() === "sterling silver") {
    material1.style.display = "";
    material2.style.display = "none";
  } else {
    material1.style.display = "none";
    material2.style.display = "";
  }
}

toggleMaterials();

radios.forEach(function (radio) {
  radio.addEventListener('change', toggleMaterials);
});
})(theme.jQuery);

function initScrollableTestimonials(container = document) {
  container.querySelectorAll('.testimonials').forEach((section) => {
    const grid = section.querySelector('.testimonials-grid');
    const prev = section.querySelector('.testimonial-scroll-prev');
    const next = section.querySelector('.testimonial-scroll-next');
    if (!grid || !prev || !next) return;
    const reviews = [...grid.querySelectorAll(':scope > .testimonial-block')];
    const shouldScroll = reviews.length > 3;
    grid.classList.toggle('has-testimonial-scroll', shouldScroll);
    if (!shouldScroll) {
      prev.disabled = true;
      next.disabled = true;
      return;
    }
    let currentIndex = 0;
    const getAmount = () => {
      const styles = getComputedStyle(grid);
      const gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;
      return reviews[0].getBoundingClientRect().width + gap;
    };
    const getVisibleCount = () => Math.max(1, Math.round(grid.clientWidth / getAmount()));
    const getMaxIndex = () => Math.max(0, reviews.length - getVisibleCount());
    const updateButtons = () => {
      currentIndex = Math.min(currentIndex, getMaxIndex());
      prev.disabled = currentIndex === 0;
      next.disabled = currentIndex === getMaxIndex();
    };
    const goToIndex = (index) => {
      currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
      grid.scrollTo({ left: currentIndex * getAmount(), behavior: 'smooth' });
      updateButtons();
    };
    if (grid.dataset.initialised === 'true') return;
    grid.dataset.initialised = 'true';
    prev.addEventListener('click', () => goToIndex(currentIndex - 1));
    next.addEventListener('click', () => goToIndex(currentIndex + 1));
    window.addEventListener('resize', () => goToIndex(currentIndex));
    updateButtons();
  });
}
document.addEventListener('DOMContentLoaded', () => initScrollableTestimonials());
document.addEventListener('shopify:section:load', (event) => initScrollableTestimonials(event.target));